import api, { ReferenceGuideSection } from '@api';
import { Typography } from '@mui/material';
import { useAsyncEffect, usePageMessage } from '@tsp-ui/core/utils';
import { useGetCurrentAccount } from '@utils/hooks';
import Page from '@views/components/Page';
import { useCallback, useState } from 'react';

import styles from './CustomerReferenceGuideManagementPage.module.scss';
import { CustomerReferenceGuideCard } from './components/CustomerReferenceGuideCard';


interface CustomerReferenceGuideManagementPageProps {
    className?: string;
}

export default function CustomerReferenceGuideManagementPage({ className }: CustomerReferenceGuideManagementPageProps) {
    const [ loading, setLoading ] = useState(true);
    const [ referenceGuideSections, setReferenceGuideSections ] = useState<ReferenceGuideSection[]>([]);
    const pageMessage = usePageMessage();
    const { id: clientID } = useGetCurrentAccount();

    useAsyncEffect(useCallback(async () => {
        try {
            setReferenceGuideSections(await api.referenceGuides.getReferenceGuideSections(clientID));
        } catch (error) {
            pageMessage.handleApiError('An error occurred while fetching the reference guides', error);
        }

        setLoading(false);
    }, [ clientID, pageMessage ]));

    return (
        <Page
            header="Reference guides"
            loading={loading}
            className={className}
        >
            {referenceGuideSections.map(({ id, title, files }) => (
                <div key={id}>
                    <Typography
                        variant="h5"
                        component="h1"
                        className={styles.title}
                    >
                        {title}
                    </Typography>

                    <div className={styles.referenceGuides}>
                        {files.length ? files.map(file => (
                            <CustomerReferenceGuideCard
                                key={file.id}
                                referenceGuideFile={file}
                            />
                        )) : (
                            <Typography>
                                There are no documents in this section.
                            </Typography>
                        )}
                    </div>
                </div>
            ))}
        </Page>
    );
}
